import commonMixin from '../mixins/_common';
import modalMixin from '../mixins/_modal';
import flashMessageMixin from '../mixins/_flash_messages';

/**
 * ヤフー認証案内モーダル
 */
export default {
    name: 'modalYahooAuth',
    template: '#yahoo_auth_component_template',
    data() {
        return {
            yahooLoginUrl: ''
        };
    },
    mixins: [
        commonMixin,
        modalMixin,
        flashMessageMixin
    ],
    mounted: async function() {
        const result = await this.isValidToken();
        this.emitIsValidToken(result);
    },
    created: function() {
        // 認証してコールバック画面を閉じた時にも通知
        window.addEventListener('message', (e) => {
            if (typeof e.data.action !== 'undefined' && e.data.action === 'yahoo_auth_call_back_close') {
                this.close();
                this.emitIsValidToken(true);
            }
        });
    },
    emits: ['is-valid-token'],
    methods: {
        // yahooAPI用アクセストークンが有効かチェック。
        // - アクセストークン未登録の場合
        //   サーバー側からfalseが返され、Yahooログイン認証画面URLを返す。
        // - アクセストークン登録済みの場合
        //   サーバー側でアクセストークンが有効かチェック
        //   - 有効の場合
        //     サーバー側からtrueが返され、ログイン認証成功画面URLを返す。
        //   - 無効の場合
        //     リフレッシュトークンを元にアクセストークンの取得を行う。
        //     - 取得できた場合
        //       新アクセストークンでDB更新する。
        //     - 取得できない場合
        //       サーバー側からfalseが返され、Yahooログイン認証画面URLを返す。
        async isValidToken () {
            // adminユーザーの場合はtrueで抜ける
            if (this.isAdmin) {
                return true;
            }
            let res = null;
            this.$_loading();
            try {
                res = await axios.post('/yahoo_auth/is_valid_token', {
                    _method: 'GET',
                });
            } catch (e) {
                res = e;
            }
            this.$_unloading();
            if (typeof res.data !== 'undefined' && res.data.status === 'OK' && res.data.result === true) {
                return true;
            }
            this.error(res);
            return false;
        },
        // ヤフー認証画面を開く
        async openYahooLoginWindow () {
            const w = 1100;
            const h = 450;
            const params = [
                'width=' + w,
                'height=' + h,
                'left=' + (screen.width-w) / 2,
                'top=' + (screen.height-h) / 2,
            ].join(',');
            window.open(this.yahooLoginUrl, '_blank', params);
        },
        // isValidTokenが失敗した時のエラー処理
        error: function (res) {
            console.log(res);
            let message = null;
            if (typeof res.data !== 'undefined') {
                if (res.data.status === 'OK') {
                    this.yahooLoginUrl = res.data.url;
                    this.open();
                } else {
                    message = res.data.message;
                }
            } else {
                message = this.getCatchMessage(res);
            }
            if (message) {
                this.appendFlashMessage({
                    level: 'alert-danger',
                    message: message,
                }, this.$parent);
            }
        },

        // -------------------------
        // emit
        // -------------------------

        /**
         * 親コンポーネントに結果を返す
         */
        emitIsValidToken: function (boolean) {
            this.$emit('is-valid-token', boolean);
        },
    }
};